import { render } from "./footer.vue?vue&type=template&id=6b5752f1&scoped=true&ts=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=6b5752f1&lang=scss&scoped=true"

import exportComponent from "/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5752f1"]])

export default __exports__